import Vue from "vue";
import CommonTable from "./CommonTable/CommonTable";
import CommonDialog from "./CommonDialog/CommonDialog";
import Pagination from "./Pagination/Pagination";
import TableToolbar from "./TableToolbar/TableToolbar";
import CommonCard from "./CommonCard/CommonCard";
const components = [CommonTable, CommonDialog, Pagination, TableToolbar, CommonCard];

components.forEach(component => {
  component.install = function() {
    Vue.component(component.name, component);
  };
});
export default components;
